import { reqGetAuthSignature } from "../api/index"

export const getAuthSignatureApi = async () => {
    const res = await reqGetAuthSignature();
    return {
        sign: res?.data?.sign || '',
        sign_time: res?.data?.sign_time || '',
    };
}
